export default __webpack_public_path__ + "soil-800-b52df47cf245c6e9eb28705d9a89cf62.webp";